module.exports = __webpack_public_path__ + "static/LOGOBLANC-VERT-bfbd806cf5660b67f73056d111fad20f.svg";